import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecisionAnswer {
    /**
     * @constructor
     */
    constructor(id, answer, feedback, rating, locked) {
        this._id = id;
        this._answer = answer;
        this._feedback = feedback;
        this._rating = rating;
        this._locked = locked;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get answer() {
        return this._answer;
    }

    set answer(value) {
        this._answer = value;
    }

    get feedback() {
        return this._feedback;
    }

    set feedback(value) {
        this._feedback = value;
    }

    get rating() {
        return this._rating;
    }

    set rating(value) {
        this._rating = value;
    }

    get locked() {
        return this._locked;
    }

    set locked(value) {
        this._locked = value;
    }

    toObject() {
        return {
            id: this._id,
            answer: this._answer,
            feedback: this._feedback,
            rating: this._rating,
            locked: this._locked
        };
    }

    fromObject(obj) {
        this._id = obj.id;
        this._answer = obj.answer;
        this._feedback = obj.feedback;
        this._rating = obj.rating;
        this._locked = obj.locked;
    }
}
KeyDecisionAnswer.GOOD_RATING = "good"
KeyDecisionAnswer.MEDIUM_RATING = "medium"
KeyDecisionAnswer.BAD_RATING = "bad"